import React, {useState, useEffect, useCallback} from 'react'
import './pageStyles/crew.min.css'
import Header from '../components/header/header'
import HeroDescription from '../components/heroDescription/index'
import PageHeading from '../components/pageHeading/index'
import PlanetImage from '../components/planetImage/index'
import SliderDots from '../components/sliderDots/index'



const Crew = ({
  crewData
}) => {
    // This is to set the background coz i've been having some trouble setting the background of the various pages using CSS
    const desktopBG = "url('/assets/crew/background-crew-desktop.jpg')"
    const mobileBG = "url('/assets/crew/background-crew-tablet.jpg')"
    
    const memoizedScreenCheck = useCallback(() => {
      if (window.innerWidth < 1000) {
        document.body.style.backgroundImage = mobileBG
      } else {
        document.body.style.backgroundImage = desktopBG
      }
    }, [window.innerWidth])
  
    useEffect(() => {
      memoizedScreenCheck()
    }, [memoizedScreenCheck])

  // Statefull Elements
  const [currentCrew, setCurrentCrew] = useState({
    data: crewData[0],
    activeDot: 1
  })
  const handleCurrentCrew = (number) => {
    if (number > crewData.length) number = 1
    setCurrentCrew({
      data: crewData[number-1],
      activeDot: number
    })
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      handleCurrentCrew(currentCrew.activeDot + 1)
    }, 10000);

    return () => {
      clearTimeout(timeout)
    }
  }, [currentCrew.activeDot])




  return (
    <>
    <div className="container">
      <Header activeLink='3'/>
      <div className="MainContainer padding-16" style={{ minHeight: 'fit-content' }}>
        <PageHeading number="02" text="MEET YOUR CREW"/>
      </div>

      <div className="MainContainer">
        <div className="MainChild">
          <HeroDescription mainTextMedium={currentCrew.data.name} mediumText={currentCrew.data.role} description={currentCrew.data.bio}/>
          <div className="container">
            <SliderDots number="4" active={currentCrew.activeDot}
            onClickHandler={handleCurrentCrew}/>
          </div>
        </div>
        <div className="">
          <PlanetImage
            image={currentCrew.data.images.png}
            name={currentCrew.data.name}
            isFull
          />
        </div>
      </div>
    </div>
    </>
  )
}



export default Crew